import { render, staticRenderFns } from "./leecherosLiquidar.vue?vue&type=template&id=4f18098f&"
import script from "./leecherosLiquidar.vue?vue&type=script&lang=js&"
export * from "./leecherosLiquidar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports